<h1 mat-dialog-title>{{ title }}</h1>
<div mat-dialog-content>{{ message }}</div>
<div mat-dialog-actions>
  <button
    mat-raised-button
    (click)="dialogRef.close(true)"
    type="submit"
    color="accent"
    (keydown.enter)="dialogRef.close(true)"
  >
    Yes
  </button>
  <button
    mat-raised-button
    (click)="dialogRef.close(false)"
    type="submit"
    color="accent"
    (keydown.enter)="dialogRef.close(false)"
  >
    No
  </button>
</div>
